var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormGroup",
    { attrs: { "add-invalid-class": false } },
    [
      _vm.forCollective
        ? _c(
            "FormGroup",
            { staticClass: "mb-2" },
            [
              _c("RadioGroup", {
                attrs: { options: _vm.collectiveOptions, stacked: "" },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.collective,
                  callback: function($$v) {
                    _vm.collective = $$v
                  },
                  expression: "collective"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.salaryEligible
        ? [
            _vm.hint
              ? _c("div", { staticClass: "mr-2 mb-1" }, [
                  _vm._v(_vm._s(_vm.hint))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "FormGroup",
              {
                attrs: {
                  state: _vm.salaryInputValid,
                  "invalid-feedback":
                    _vm.salaryInputError && _vm.salaryInputError.show
                      ? _vm.salaryInputError.text
                      : "",
                  "feedback-beneath": ""
                }
              },
              [
                _vm.range
                  ? [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c("div", { staticClass: "mr-1" }, [_vm._v("Von")]),
                          _vm._v(" "),
                          _c("b-input", {
                            staticClass: "d-inline-block mr-1",
                            staticStyle: { width: "6rem" },
                            attrs: { placeholder: "zB: 2000" },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.salaryInput,
                              callback: function($$v) {
                                _vm.salaryInput = $$v
                              },
                              expression: "salaryInput"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "mr-1" }, [_vm._v("bis")]),
                          _vm._v(" "),
                          _c("b-input", {
                            staticClass: "d-inline-block",
                            staticStyle: { width: "6rem" },
                            attrs: { placeholder: "zB: 2500" },
                            on: { input: _vm.emitChangeEvent },
                            model: {
                              value: _vm.salaryInputMax,
                              callback: function($$v) {
                                _vm.salaryInputMax = $$v
                              },
                              expression: "salaryInputMax"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-md-center flex-column flex-md-row"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "mr-4 d-flex align-items-center" },
                            [
                              _c(
                                "div",
                                [
                                  _c("b-input", {
                                    staticClass: "d-inline-block mr-1",
                                    staticStyle: { width: "6rem" },
                                    attrs: {
                                      placeholder: _vm.placeholderNonRange
                                    },
                                    on: { input: _vm.salaryInputChanged },
                                    model: {
                                      value: _vm.salaryInput,
                                      callback: function($$v) {
                                        _vm.salaryInput = $$v
                                      },
                                      expression: "salaryInput"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", [_vm._v("€")])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-grow-1 mt-2 mt-md-0" },
                            [_vm._t("input-info")],
                            2
                          )
                        ]
                      )
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _vm.withCalculatorLink
              ? _c("div", { staticClass: "mt-3" }, [
                  _vm._v("\n\t\t\tZum Brutto-Netto-Rechner:\n\t\t\t"),
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.calculatorLinks.AT, target: "_blank" }
                    },
                    [_vm._v("Österreich")]
                  ),
                  _vm._v("\n\t\t\t| "),
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.calculatorLinks.DE, target: "_blank" }
                    },
                    [_vm._v("Deutschland")]
                  ),
                  _vm._v("\n\t\t\t| "),
                  _c(
                    "a",
                    {
                      attrs: { href: _vm.calculatorLinks.CH, target: "_blank" }
                    },
                    [_vm._v("Schweiz")]
                  )
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }